module.exports = __webpack_public_path__ + "img/image.ef299ca7.jpg";